import { render, staticRenderFns } from "./posMemberList.vue?vue&type=template&id=042fb4fb"
import script from "./posMemberList.vue?vue&type=script&lang=js"
export * from "./posMemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports